/* kq-header: hover intent, sticky shrink, mobile drawer, dismissible announcement.
   Vanilla and self-contained so the old header's jQuery plugins stay untouched. */
(function () {
  'use strict';

  var OPEN_DELAY = 300;   // Baymard: opening on hover with no delay flickers as
  var CLOSE_DELAY = 200;  // the cursor crosses the bar. Close is shorter so a
                          // diagonal move toward the panel does not dismiss it.

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    var root = document.querySelector('[data-kq-header]');
    if (!root) return;

    /* ---- desktop dropdowns ---- */
    var openTimer = null, closeTimer = null, current = null;

    function close(item) {
      if (!item) return;
      var drop = item.querySelector('.kq-drop');
      var top = item.querySelector('.kq-nav__top');
      if (drop) drop.hidden = true;
      if (top) top.setAttribute('aria-expanded', 'false');
      item.classList.remove('is-open');
      if (current === item) current = null;
    }

    function positionDrop(drop) {
      // Right-hand categories still need to fit when their dropdown has several groups.
      drop.style.setProperty('--kq-drop-offset', '0px');
      var bounds = drop.getBoundingClientRect();
      var offset = Math.min(0, document.documentElement.clientWidth - 16 - bounds.right);
      drop.style.setProperty('--kq-drop-offset', Math.max(offset, 16 - bounds.left) + 'px');
    }

    function open(item) {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      if (current && current !== item) close(current);
      var drop = item.querySelector('.kq-drop');
      var top = item.querySelector('.kq-nav__top');
      if (drop) {
        drop.hidden = false;
        positionDrop(drop);
      }
      if (top) top.setAttribute('aria-expanded', 'true');
      item.classList.add('is-open');
      current = item;
    }

    window.addEventListener('resize', function () {
      if (current) positionDrop(current.querySelector('.kq-drop'));
    });

    root.querySelectorAll('.kq-nav__item.has-drop').forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () { open(item); }, OPEN_DELAY);
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () {
          if (!item.contains(document.activeElement)) close(item);
        }, CLOSE_DELAY);
      });
      // keyboard: the top link toggles, so the menu is reachable without a mouse
      var top = item.querySelector('.kq-nav__top');
      top.addEventListener('keydown', function (e) {
        if (e.key === ' ') {
          e.preventDefault();
          if (current === item) close(item);
          else open(item);
        } else if (e.key === 'Enter') {
          if (!item.classList.contains('is-open')) { e.preventDefault(); open(item); }
        }
      });
      item.addEventListener('focusout', function () {
        setTimeout(function () {
          if (!item.contains(document.activeElement)) close(item);
        }, 0);
      });
    });

    var nav = root.querySelector('.kq-nav');
    if (nav) nav.addEventListener('keydown', function (e) {
      var item = e.target.closest('.kq-nav__item');
      if (!item) return;
      var top = item.querySelector('.kq-nav__top');
      var links = Array.from(item.querySelectorAll('.kq-drop a[href]'));
      var index = links.indexOf(e.target);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!links.length) return;
        e.preventDefault();
        open(item);
        var next = e.key === 'ArrowDown' ? index + 1 : index - 1;
        if (e.target === top) next = e.key === 'ArrowDown' ? 0 : links.length - 1;
        links[(next + links.length) % links.length].focus();
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault();
        var tops = Array.from(nav.querySelectorAll('.kq-nav__top'));
        var offset = e.key === 'ArrowRight' ? 1 : -1;
        close(current);
        tops[(tops.indexOf(top) + offset + tops.length) % tops.length].focus();
      } else if ((e.key === 'Home' || e.key === 'End') && index !== -1) {
        e.preventDefault();
        links[e.key === 'Home' ? 0 : links.length - 1].focus();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && current) {
        e.preventDefault();
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        var top = current.querySelector('.kq-nav__top');
        close(current);
        if (top) top.focus();
      }
    });

    /* ---- sticky shrink ---- */
    var shrinkAt = 80, shrunk = false, ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var should = window.scrollY > shrinkAt;
        if (should !== shrunk) {
          shrunk = should;
          root.classList.toggle('is-shrunk', shrunk);
        }
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* ---- mobile drawer ---- */
    var drawer = root.querySelector('#kq-drawer');
    var scrim = root.querySelector('.kq-drawer__scrim');
    var burger = root.querySelector('.kq-header__burger');
    var closeBtn = root.querySelector('.kq-drawer__close');
    var desktop = window.matchMedia('(min-width: 990px)');

    function setDrawer(openIt) {
      if (!drawer) return;
      var hadFocus = drawer.contains(document.activeElement);
      drawer.hidden = !openIt;
      if (scrim) scrim.hidden = !openIt;
      document.body.classList.toggle('kq-drawer-open', openIt);
      if (burger) burger.setAttribute('aria-expanded', String(openIt));
      if (openIt) {
        close(current);
        if (closeBtn) closeBtn.focus();
      } else if (hadFocus) {
        var target = desktop.matches ? root.querySelector('.kq-nav__top') : burger;
        if (target) target.focus();
      }
    }
    if (burger) burger.addEventListener('click', function () { setDrawer(drawer.hidden); });
    if (scrim) scrim.addEventListener('click', function () { setDrawer(false); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setDrawer(false); });

    document.addEventListener('keydown', function (e) {
      if (!drawer || drawer.hidden) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        setDrawer(false);
      } else if (e.key === 'Tab') {
        var focusable = Array.from(drawer.querySelectorAll('a[href], button, input'))
          .filter(function (el) { return !el.disabled && el.getClientRects().length; });
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (!drawer.contains(document.activeElement) || (e.shiftKey && document.activeElement === first)) {
          e.preventDefault();
          (e.shiftKey ? last : first).focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    desktop.addEventListener('change', function () {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      if (desktop.matches) setDrawer(false);
      else {
        var hadFocus = nav && nav.contains(document.activeElement);
        close(current);
        if (hadFocus && burger) burger.focus();
      }
    });

    root.querySelectorAll('.kq-drawer__toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.closest('.kq-drawer__item').querySelector('.kq-drawer__panel');
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isOpen));
        if (panel) panel.hidden = isOpen;
      });
    });

    /* ---- dismissible announcement ---- */
    var ann = root.querySelector('.kq-announce');
    var annClose = root.querySelector('.kq-announce__close');
    var KEY = 'kq-announce-dismissed';
    try {
      if (ann && localStorage.getItem(KEY) === ann.dataset.key) ann.hidden = true;
    } catch (e) { /* private mode: just show it */ }
    if (annClose && ann) {
      annClose.addEventListener('click', function () {
        ann.hidden = true;
        try { localStorage.setItem(KEY, ann.dataset.key); } catch (e) {}
      });
    }
  });
})();
